import { makeStyles } from "@mui/styles";

export const Style = makeStyles((theme) => ({
  Container: {
    margin: "auto",
    padding: theme.spacing(2),
    background: "#fcfcfc",
    maxWidth: 1200,
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(3),
    }
  },
  Item: {
    background: "#fff",
    borderRadius: 16,
    marginBottom: theme.spacing(3),
    border: `1px solid ${theme.palette.divider}`,
    overflow: 'hidden',
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(3),
    }
  },
  Check: {
    color: theme.palette.success.main + "!important",
    fontSize: "20px !important",
    marginRight: theme.spacing(1),
  },
  Titulo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: theme.spacing(4),
  },
  Bloco: {
    [theme.breakpoints.up("md")]: {
      borderLeft: `1px solid ${theme.palette.divider}`,
      paddingLeft: theme.spacing(4),
    },
    [theme.breakpoints.down("md")]: {
      borderTop: `1px solid ${theme.palette.divider}`,
      paddingTop: theme.spacing(3),
    }
  },
  img: {
    borderRadius: 8,
    [theme.breakpoints.up("sm")]: {
      maxWidth: 120,
    },
  },
}));